import Trait from './Trait';

export default function Traits({ fields, remove, form }: any) {
  return fields.map((field: any) => {
    return <Trait field={field} remove={remove} form={form} />;
  });
}
